import React, { useState } from "react";
import PropTypes from "prop-types";

const ImageWithFallback = ({ sources, initials }) => {
  const [index, setIndex] = useState(0);
  const source = sources[index];
  return source ? (
    <img src={source} alt="" className="rounded-circle wh-40 profile-image-obj"
      onError={() => setIndex(index + 1)} />
  ) : (
    <div className="user-initial text-uppercase profile-image-height wh-40">{initials}</div>
  );
};

const ProfileImage = ({ user }) => {
  const sources = [...new Set([user.profile_photo_url, user.salon?.logo_url]
    .filter(value => typeof value === "string" && value.trim())
    .map(value => value.trim()))];
  const initials = [user.first_name, user.last_name]
    .map(value => typeof value === "string" ? value.trim().charAt(0) : "")
    .join("") || "?";
  // Reset failures when the account, salon, or saved image changes.
  const imageKey = JSON.stringify([user.id, user.salon_id, user.salon?.id, sources]);
  return <ImageWithFallback key={imageKey} sources={sources} initials={initials} />;
};

ImageWithFallback.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.string).isRequired,
  initials: PropTypes.string.isRequired,
};

const identifier = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
ProfileImage.propTypes = {
  user: PropTypes.shape({
    id: identifier,
    salon_id: identifier,
    profile_photo_url: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    salon: PropTypes.shape({id: identifier, logo_url: PropTypes.string}),
  }).isRequired,
};

export default ProfileImage;
